<template>
	<base-nav
		v-model="showMenu"
		class="navbar-absolute top-navbar"
		type="white"
		:transparent="true"
	>
		<div slot="brand" class="navbar-wrapper">
			<div class="navbar-minimize d-inline"><sidebar-toggle-button /></div>
			<div
				class="navbar-toggle d-inline"
				:class="{ toggled: $sidebar.showSidebar }"
			>
				<button type="button" class="navbar-toggler" @click="toggleSidebar">
					<span class="navbar-toggler-bar bar1"></span>
					<span class="navbar-toggler-bar bar2"></span>
					<span class="navbar-toggler-bar bar3"></span>
				</button>
			</div>
			<a class="navbar-brand" href="#pablo">{{ routeName }}</a>
			<span>{{this.vidos}}</span>
		</div>

		<ul class="navbar-nav align-items-center" :class="$rtl.isRTL ? 'mr-auto' : 'ml-auto'">
			<!--li class="dropdown nav-item"><a class="mailLink" @click="loginMail()" target="_blank"><i class="tim-icons icon-email-85 text-primary"></i><span v-if="unread==true" class="mailDot"></span> </a> </li-->
			<!-- <li class="dropdown nav-item"><a :href="`mailto:${$GVO.my_profile.email}`"><i class="tim-icons icon-email-85 text-primary"></i></a> </li> -->
			
			<li class="dropdown nav-item learnReactor" v-if="(videoParents && videoParents!='none' && videoParents!='') || (videoChildren && videoChildren!='none' && videoChildren!='')"  @click="openVideo()">
				
				<a  :href="videolink" target="__blank" > <div class="navMobile-descr">Обучение</div> <i class="tim-icons icon-video-66 text-primary" ></i></a>
			</li>

			<li class="dropdown nav-item network"><i class="fa fa-wifi on-mobile " :class="[{'networked':$GVO.api_loading_counter==0},{'networking':$GVO.api_loading_counter>0}]"></i></li>
			<li class="dropdown nav-item billing">
				<router-link to="/data/billing/my_money?range_type=5" class="mt-3" >
					<div class="navMobile-descr">Биллинг</div>
					<span class="badge badge-primary" v-if="$GVO.iTechBalance != ''">{{ $GVO.iTechBalance }} ₽</span>
					<span class="badge badge-primary" style="min-width: 50px;" v-if="$GVO.iTechBalance == ''">0 ₽</span>
				</router-link>
			</li>
			<div class="navDesktop">
			<base-dropdown
				tag="li"
				:menu-on-right="!$rtl.isRTL"
				title-tag="a"
				class="nav-item"
				title-classes="nav-link"
				menu-classes="dropdown-navbar"
				>
				<template
					v-slot:title
				>
					<div class="photo"><img v-if="typeof $GVO.my_profile.code != 'undefined'" :src="$GVO.endpoint_domen+'/ajaxdata/getImg.php?code='+$GVO.my_profile.code" /><img v-else src="/img/mike.jpg" /></div>
					<b class="caret d-none d-lg-block d-xl-block"></b>
					<!-- <p class="ml-3 d-lg-none">Меню | Профиль</p> -->
				</template>
				<router-link class="nav-item" tag="li" :to="'/data/staff/id/'+$GVO.my_profile.code">
					<a class="nav-item dropdown-item">Профиль</a>
				</router-link>				
				<li class="nav-item" @click="GoToSettings()">
					<div class="nav-item dropdown-item">Настройки интерфейса</div>
				</li>
				<A2HSInstallPrompt />
				<div class="dropdown-divider"></div>
				<li class="nav-link">
					<a class="nav-item dropdown-item" @click="$GVO.LogOut();">Выход</a>
				</li>
			</base-dropdown></div>
			
			<div class="navMobile">
				<ul >
					<router-link class="nav-link" tag="li" :to="'/data/staff/id/'+$GVO.my_profile.code">
						<a class="nav-item dropdown-item">Профиль</a>
					</router-link>				
					<li class="nav-link" @click="GoToSettings()">
						<div class="nav-item dropdown-item">Настройки интерфейса</div>
					</li>
					<A2HSInstallPrompt />
					<div class="dropdown-divider"></div>
					<li class="nav-link">
						<a class="nav-item dropdown-item" @click="$GVO.LogOut();">Выход</a>
					</li>
					
				</ul>
			</div>
		</ul>
	</base-nav>
</template>
<script>
// import { CollapseTransition } from 'vue2-transitions';
import { BaseNav/*, Modal*/ } from '@/components';
import SidebarToggleButton from './SidebarToggleButton';
import A2HSInstallPrompt from 'src/our_components/addtohomescreen/A2HSInstallPrompt.vue';
// import swal from 'sweetalert2';

export default {
	components: {
		SidebarToggleButton,
		// CollapseTransition,
		BaseNav,
		// Modal,
		A2HSInstallPrompt
	},
	props: {
		videoParents: {
			type: String,
			default: 'none',
		},
		videoChildren: {
			type: String,
			default: 'none',
		},

	},
	watch: {
		routeName(oldVal, newVal){
			// console.log('close menu')
			this.showMenu = false;
			this.updateTitle();
		}
	},
	computed: {
		routeName() {
			const { name } = this.$route;
			// console.log('this.$route', this.$route);
			return this.capitalizeFirstLetter(name);
		},
		isRTL() {
			return this.$rtl.isRTL;
		}
	},
	data() {
		return {
			activeNotifications: false,
			showMenu: false,
			searchModalVisible: false,
			searchQuery: '',
			showInstallMenu: true,
			unread: 0,
			haveUnread: false,
			unreadCheck: undefined,
			videolink: '',
			masMenu: [],
			vidos: '',
			defaultTitle:'',
		};
	},
	methods: {
		capitalizeFirstLetter(string) {
			if(typeof string != 'undefined'){
				return string.charAt(0).toUpperCase() + string.slice(1);
			}else{
				// console.trace(string);
				return '404';
			}
		},
		handleTitleUpdate(event) {
			// console.log(event);
			if(event.detail && event.detail.title){
				this.updateTitle(event.detail.title)
			}
		},		
		updateTitle(append){
			// console.log('update-title',this.$route.meta.pageTitle,append)
			/*
			let m = this.$route.matched;
			if(m.length){
				let c=m[m.length-1].components.default;
				if(c && c.)
			}
			*/
			if(this.$route.meta.pageTitle){
				document.title='Reactor CRM | ' + this.$route.meta.pageTitle + (append?' | ' + append:'');
			}else{
				document.title = this.defaultTitle;
			}
		},
		toggleNotificationDropDown() {
			this.activeNotifications = !this.activeNotifications;
		},
		closeDropDown() {
			this.activeNotifications = false;
		},
		toggleSidebar() {
			this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
		},
		hideSidebar() {
			this.$sidebar.displaySidebar(false);
		},
		toggleMenu() {
			this.showMenu = !this.showMenu;
		},
		GoToSettings(bGoEdit=true){
			//this.bIsEdit = bGo;
			if(bGoEdit){
				this.$router.push({path: '/data/staff/id/'+this.$GVO.my_profile.code+'/settings'});		
			}else{
				this.$router.push({path: '/data/staff/id/'+this.$route.params.code});
			}
		},
		/*
		//яндекс более не предоставляет такое апи
		loginMail(){
			this.$GVO.ApiCall('login_link',{"obj":"yandex"}).then(result=>{
				if(result.data){
					window.open(result.data);
				}
			}).catch(console.log);
		},*/
		checkUnread(){
			/*
			this.$GVO.ApiCall('unread',{"obj":"yandex"}).then(result=>{
				if(result && result.data && result.data.new_message){
					this.unread = Number(result.data.new_message);
				}else{
					this.unread = 0;
				}
				this.haveUnread=this.unread>0;

			}).catch(console.log);
			*/
			this.getTechBalance();
		},
		getTechBalance(){
			this.$GVO.ApiCall('billing.getTechBalance',{"flt":{'list':'all'}})
			.then((objApi) => {
				if(objApi.success === true){
					this.$GVO.iTechBalance = parseFloat(objApi.data.tech_balance);
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		
		openVideo(){
			//закоменченый блок для вывода встроенного видео, не удалять.
			// let link = '';
			// if(this.videoParents && this.videoParents!='none'  && this.videoParents!='') {
			// 	link = this.videoParents;
			// } else {link = this.videoChildren;}
			// this.videolink =  link.substring(link.indexOf("=") + 1, link.indexOf("&"));

			if(this.videoParents && this.videoParents!='none' && this.videoParents!='') {
				this.videolink = this.videoParents;
			} else if (this.videoChildren && this.videoChildren!='none' && this.videoChildren!='') {this.videolink = this.videoChildren;}
			
			// if(this.videolink != null){
			// 	this.$router.push({path: this.videolink});
			// 	console.log(this.videolink);
			// 	window.open(this.videolink, '__blank');
			// 	// window.open("yourURL", '_blank');
			// }

				// swal({
				// 	title: 'Обучающее видео',
				// 	buttonsStyling: false,
				// 	confirmButtonClass: 'btn btn-danger btn-fill',
				// 	// html: `<video controls width="auto" height="auto" >
				// 	// 	<source src="${this.learnReactor}" >
				// 	// 	</video>   `,
				// 	html: `<iframe  width="800" height="400" src="https://www.youtube.com/embed/${videolink}?modestbranding=1;rel=0;"
				// 			frameborder="0"
							
				// 			allowfullscreen>
				// 			</iframe>   `,
				// });

		},
		getAllMenu(){
			this.$GVO.ApiCall('menu_adm.GET',{flt:{'list': true, 'c2p':100}} )
				.then((objApi) => {
					//console.log('menu',objApi);
					if(objApi.success === true){
						if(objApi.data.length > 0){
							this.masMenu = objApi.data;
							this.vidos = '';
							for(let i = 0; i < this.masMenu.length; i++){
								// this.masMenu.push([{path: objApi.data.path,}])
								if(this.$route.path == this.masMenu[i].path ){
									this.vidos = this.masMenu[i].videoUrl;
								}
							}
							
						}
					}
				}).catch(errorObjApi => console.error(errorObjApi));
		}
		
	},
	mounted(){
		this.unreadCheck = setInterval(()=>this.checkUnread(),60000);
		this.checkUnread();
		this.defaultTitle = document.title;
		window.addEventListener('update-title', this.handleTitleUpdate);
	},
	unmounted(){
		clearInterval(this.unreadCheck)
		window.removeEventListener('update-title', this.handleTitleUpdate);
	},
	created() {

	},
};
</script>
<style scoped>
	.top-navbar {
		top: 0px;
	}

	.fa-wifi{padding: 0.5rem 0.7rem;}
	/*.fa-wifi.on-mobile{display: none;}*/

	.networked{
		color:green;
	}
	.networking{
		color:orange;
		-webkit-animation: blink 2s linear infinite;
		animation: blink 2s linear infinite;
	}
	.mailLink {cursor: pointer; position: relative;}
	.mailDot {
		position: absolute;
		height: 8px;
		width: 8px;
		display: block;
		background: #F84E54;
		border-radius: 50%;
		bottom: 12px;
		right: -5px;
	}
	.learnReactor {cursor: pointer;}
	.ytp-impression-link{display: none!important}
	.navMobile {display: none;}
	.navMobile-descr {margin-right: 10px; display: none;}

	/*===media===============================*/
	@media (max-width: 992px) {	
		.navMobile {display: flex; list-style: none; padding-left: 0px;}
		/* .navMobile ul {display: flex; flex-direction: column; list-style: none; padding-left: 0px;} */
		.navMobile >>> .nav-item{color: #222a42!important;}
		.navDesktop, .network {display: none;}
		.navMobile-descr {display: inline-flex; color: #222a42!important; font-size: 0.875rem;}
		.learnReactor, .billing{display: inline-flex; align-items: baseline; padding: 0px;}
		.learnReactor{margin-left: -15px!important;}
		.navbar .navbar-nav .dropdown  {margin-top: 0px; margin-bottom: 0px;}
		.billing a, .navbar-nav {margin-top: 10px!important;}
		/* .dropdown-navbar {display: none;} */
	}	

</style>
